import { Directive, Output, EventEmitter, ElementRef, HostListener } from '@angular/core';

// * https://christianliebel.com/2016/05/angular-2-a-simple-click-outside-directive/
// * https://github.com/arkon/ng-click-outside
// * https://www.bennadel.com/blog/3009-tracking-click-events-outside-the-current-component-in-angular-2-beta-1.htm
@Directive({
    // tslint:disable-next-line: directive-selector
    selector: '[clickOutsideRowDetails]',
    standalone: false
})
export class ClickOutsideRowDetailsDirective
{
    @Output() public clickOutsideRowDetails = new EventEmitter();

    constructor(private elementRef: ElementRef) { }

    @HostListener('document:mousedown', ['$event'])
    public onClick ($event: MouseEvent)
    {
        // TODO ! Mettre 6 lignes de code suivantes en fonction utilitaires
        const boundingClientRect = this.elementRef.nativeElement.firstChild.getBoundingClientRect();
        const { top, bottom, left, right } = boundingClientRect;
        const { x, y } = $event;
        const isInsideX = x >= left && x <= right;
        const isInsideY = y >= top && y <= bottom;

        const clickedOutside = !(isInsideX && isInsideY);

        if (clickedOutside)
        {
            const row: HTMLElement = (<HTMLElement>$event.target).parentElement;
            if (row !== null)
            {
                const classList = Array.from(row.classList);
                const isRowDetails: boolean = classList.includes('row-details-container') || classList.includes('row-details');

                if (!isRowDetails)
                {
                    this.clickOutsideRowDetails.emit();
                } else
                {
                    return;
                }
            } else
            {
                this.clickOutsideRowDetails.emit();
            }
        }
    }
}
